module.exports = __webpack_public_path__ + "img/img_C3.12.17.0a36cc11.png";